import PropTypes from 'prop-types';
import styles from './PrintLink.module.css';

export default function PrintLink({ onClick }) {
    const handleClick = () => {
        if (onClick) {
            onClick();
        }

        // Open print page in new tab
        window.open('/print.html', '_blank');
    };

    return (
        <button className={styles.viewBtn} onClick={handleClick}>
            Print/PDF
        </button>
    );
}

PrintLink.propTypes = {
    onClick: PropTypes.func,
};
